var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlluBgFun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578.51 482.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff032;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_No_Risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.73,159.43C25.46,200.67,12.6,246.6,5.43,292.88,2.62,311,.66,329.46,3.12,347.63c5.4,39.85,32.32,75.4,67.41,97.9s77.63,32.89,119.9,35.31c34.68,2,73.75-11.27,94.18-37.91,16-20.87,23.46-74.93,41-82.52,91.32-39.53,106.15,16.95,156-22.76,25-19.92,71.72-32.32,77.09-51,15.13-52.72,19.43-63.94,17.46-110.46-1.48-35.31-15.58-67-39.79-93.89-24-26.68-57-35.85-93.17-43.26s-93.05-18.65-130-19.33C248.8,18.53,220,10.4,160.59,40.18c-19.33,9.69-33.29,26.53-48,41.4C88.45,106.05,65.57,129.6,48.73,159.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.45,10.22C75.58,0,90.54-.59,105.26,4.8c16.11,5.89,21.57,27.93,14.25,44.57s-24,27.8-41,33.16c-2.82.89-5.76,1.66-8.62,1.32-3.26-.39-6.1-2.2-8.55-4.3C51.15,70.83,46.62,57,44.27,43.47c-1.65-9.53-1-22,7.91-26.43C52.18,17,58.53,13.26,62.45,10.22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluBgFun);
export default __webpack_public_path__ + "static/media/illu_bg_fun.a7cd6d1f5a19296e25b221ef6d073d4a.svg";
export { ForwardRef as ReactComponent };